<template>
  <div>
    <!-- 列表页面 -->
    <div class="container">
      <div style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >监控告警</el-breadcrumb-item>
          <el-breadcrumb-item >设备监控</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 柱状图 -->
      <div class="user-distribution" v-if="showEquipStat==true">
        <dv-border-box-12 style="padding-right: 5px;">
          <div class="handle-distribution">
            <div class="handle-one" style="margin-left: 20px;">
              <div class="line-left">
                <p><</p><span><</span>
              </div>
              <dv-border-box-1 title="">
                <div class="line-middle">
                  <p class="line-middle-rate"><span>{{faultedAmount}}</span>台</p>
                  <p class="line-middle-status">故障</p>
                </div>
              </dv-border-box-1>
              <div class="line-right">
                <span>></span><p>></p>
              </div>
            </div>
            <div class="handle-one" style="margin-left: 20px;">
              <div class="line-left">
                <p><</p><span><</span>
              </div>
              <dv-border-box-1 title="">
                <div class="line-middle">
                  <p class="line-middle-rate-processing"><span>{{surgeryAmount}}</span>台</p>
                  <p class="line-middle-status">手术中</p>
                </div>
              </dv-border-box-1 >
              <div class="line-right">
                <span>></span><p>></p>
              </div>
            </div>
            <div class="handle-one" style="margin-left: 20px;">
              <div class="line-left">
                <p><</p><span><</span>
              </div>
              <dv-border-box-1 title="">
                <div class="line-middle">
                  <p class="line-middle-rate-normal"><span>{{onAmount}}</span>台</p>
                  <p class="line-middle-status">正常</p>
                </div>
              </dv-border-box-1 >
              <div class="line-right">
                <span>></span><p>></p>
              </div>
            </div>
            <div class="handle-one" style="margin-left: 20px;">
              <div class="line-left">
                <p><</p><span><</span>
              </div>
              <dv-border-box-1 title="">
                <div class="line-middle">
                  <p class="line-middle-rate-close"><span>{{offAmount}}</span>台</p>
                  <p class="line-middle-status">关机</p>
                </div>
              </dv-border-box-1 >
              <div class="line-right">
                <span>></span><p>></p>
              </div>
            </div>
          </div>
        </dv-border-box-12>
      </div>

        <div class="table-content">
          <div class="header-common" >
            <div class="header-common-left">
              <div class="title">设备监控</div>
            </div>
            <header class="header-common-right">
              <el-button
                class="right-button-export"
                @click="exportTable(1)"
                type="text"
                >
                导出
              </el-button>
            </header>
          </div>
          <div class="table-list">
            <el-table
              v-loading='loading'
              border
              :cell-style="tableCellStyle"
              :header-cell-style="tableHeaderCellStyle"
              :max-height="tableHeight"
              :data="tableData.filter(data => !search || data.provinceName.toLowerCase().includes(search.toLowerCase()) || data.hospitalName.toLowerCase().includes(search.toLowerCase()) || data.type.toLowerCase().includes(search.toLowerCase()) || data.udi.toLowerCase().includes(search.toLowerCase()) || data.statusText.toLowerCase().includes(search.toLowerCase()))"

              >
              <el-table-column
                type="index"
                label="序号">
              </el-table-column>
              <el-table-column
                prop="provinceName"
                label="所在地区">
                <template slot-scope="scope">
                  {{scope.row.provinceName}}/{{scope.row.cityName}}
                </template>
              </el-table-column>
              <el-table-column
                prop="hospitalName"
                label="使用单位">
              </el-table-column>
              <el-table-column
                prop="typeName"
                label="产品名称">
              </el-table-column>
              <el-table-column
                prop="typeModel"
                label="规格型号">
              </el-table-column>
              <el-table-column
                prop="udi"
                label="设备UDI"
                >
                <!-- <template slot-scope="scope">
                  <el-tooltip popper-class="tooltip-back" class="item" effect="dark" placement="top-start" v-if="scope.row.realtime">
                    <div slot="content">
                      气源压力：{{scope.row.realtime.pressure}} (psi)
                      <br/>
                      冷机01 温度：{{scope.row.realtime.r01Temp}} (℃) 错误码：{{scope.row.realtime.r01ErrorCode}}
                      <br/>
                      冷机02 温度：{{scope.row.realtime.r02Temp}} (℃) 错误码：{{scope.row.realtime.r02ErrorCode}}
                    </div>
                    <span style="cursor: pointer;" >{{scope.row.udi}}</span>
                  </el-tooltip>
                  <span v-else>{{scope.row.udi}}</span>
                </template> -->
              </el-table-column>
              <el-table-column
                label="当前状态"
                prop="statusText"
                >
                <template slot-scope="scope">
                  <el-tooltip popper-class="tooltip-back" class="item" effect="dark" placement="top-start" v-if="scope.row.location && scope.row.realtime">
                    <div slot="content">
                      经度：{{scope.row.location.longitude}}
                      <br/>
                      纬度：{{scope.row.location.latitude}}
                      <br/>
                      定位时间:{{scope.row.location.time}}
                      <br/>
                      <!-- 所在地：{{scope.row.provinceName}}/{{scope.row.cityName}}
                      <br/> -->
                      <div  style="margin-top: 10px;">
                        <!-- 实时数据 -->
                        <br/>
                        气源压力：{{scope.row.realtime.pressure}} (psi)
                        <br/>
                        冷机01   温度:{{scope.row.realtime.r01Temp}} (℃) 错误码:{{scope.row.realtime.r01ErrorCode}}
                        <br/>
                        冷机02   温度:{{scope.row.realtime.r02Temp}} (℃) 错误码:{{scope.row.realtime.r02ErrorCode}}
                      </div>
                    </div>
                    <span style="cursor: pointer;" >{{scope.row.statusText}}</span>
                  </el-tooltip>
                  <el-tooltip popper-class="tooltip-back" class="item" effect="dark" placement="top-start" v-else-if="scope.row.location">
                    <div slot="content">
                      经度：{{scope.row.location.longitude}}
                      <br/>
                      纬度：{{scope.row.location.latitude}}
                      <br/>
                      定位时间:{{scope.row.location.time}}
                      <br/>
                      <!-- 所在地：{{scope.row.provinceName}}/{{scope.row.cityName}}
                      <br/> -->
                    </div>
                    <span style="cursor: pointer;" >{{scope.row.statusText}}</span>
                  </el-tooltip>
                  <el-tooltip popper-class="tooltip-back" class="item" effect="dark" placement="top-start" v-else-if="scope.row.realtime">
                    <div slot="content">
                      气源压力：{{scope.row.realtime.pressure}} (psi)
                      <br/>
                      冷机01   温度:{{scope.row.realtime.r01Temp}} (℃) 错误码:{{scope.row.realtime.r01ErrorCode}}
                      <br/>
                      冷机02   温度:{{scope.row.realtime.r02Temp}} (℃) 错误码:{{scope.row.realtime.r02ErrorCode}}
                    </div>
                    <span style="cursor: pointer;" >{{scope.row.statusText}}</span>
                  </el-tooltip>
                  <span v-else>{{scope.row.statusText}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="faultTime"
                label="故障时间">
              </el-table-column>
              <el-table-column
                prop="maintainStatusText"
                label="处理状态">
              </el-table-column>
              <el-table-column
                label="操作"
                style="display: flex;flex-direction: column;align-items: center;justify-content: center;"
                >
                <template slot="header" slot-scope="scope">
                  <el-input
                    id="search"
                    v-model="search"
                    size="mini"
                    placeholder="输入关键字搜索"/>
                </template>
                <!-- 处理状态，1-待处理，2-处理中，3-处理完成 -->
                <template slot-scope="scope">
                  <el-button
                    @click="toHandleFault(scope.row)"
                    type="text"
                    size="small"
                    class="action-button-waiting"
                    v-if="scope.row.maintainStatus == 1"
                    >立即处理
                  </el-button>
                  <router-link
                  v-else-if="scope.row.maintainStatus == 2"
                  class="action-button-process" :to="{path:'/monitor/equipment/equipment-monitor-detail',query:{id:scope.row.id,mid:scope.row.mid}}">
                    继续处理
                  </router-link>
                  <el-button
                    type="text"
                    size="small"
                    class="action-button-base"
                    @click="showMaintainRecord(scope.row)"
                    >维护记录
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
    </div>

    <template>
      <!-- //1.维修记录 -->
      <el-dialog title="维护记录" :visible.sync="dialogTableVisible" width="70%">
        <el-table
        :data="tableMaintainceData"
        :max-height="innerTableHeight"
        >
          <el-table-column
          type="index"
            label="序号">
          </el-table-column>
          <el-table-column
            prop="faultTime"
            label="故障时间">
          </el-table-column>
          <el-table-column
            prop="faultLog"
            label="故障日志">
          </el-table-column>
          <el-table-column
            prop="maintainStartTime"
            label="开始处理时间">
          </el-table-column>
          <el-table-column
            prop="maintainFinishTime"
            label="结束处理时间"
            >
          </el-table-column>
          <el-table-column
            prop=""
            label="处理时长"
            >
            <template slot-scope="scope" >
              {{scope.row.maintainDuration}}分钟
            </template>
          </el-table-column>
          <el-table-column
            prop="maintainProcess"
            label="维护内容">
          </el-table-column>
          <el-table-column
            prop="maintainerName"
            label="维护人员">
          </el-table-column>
          <el-table-column
            prop="maintainStatusText"
            label="处理状态">
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogTableVisible = false">取 消</el-button>
            <el-button type="primary" @click="exportTable(2)">导出</el-button>
        </div>
      </el-dialog>

    </template>
  </div>
</template>

<script>
  import {dataConversionUtil} from '../../../utils/excel.js'
  import {areaSimplifyConversionUtil} from '../../../utils/povince_handle.js'
  import {permissionCheckUtil} from '../../../utils/permission.js'

  export default {
    data() {
      return {
        tableHeight:0,
        innerTableHeight:0,
        search:'',

        tableData:[],
        tableMaintainceData:[],//维修记录
        loading:false,
        dialogTableVisible:false,

        showEquipStat:false,

        // 设备状态统计
        onAmount:0,//正常
        offAmount:0,//关机
        faultedAmount:0,//故障
        surgeryAmount:0,//手术
      }
    },
    computed:{
      statusColor(status){
        return (status) => {
          if (status == 1) {
            return {'color':'#1EC88E'}
          }else if (status == 2) {
            return {'color':'#C6C6C6'}
          }else if (status == 3) {
            return {'color':'#ED3030'}
          }
        }
      }
    },
    methods:{
      tableCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);text-align:center;font-size: 14px;font-weight: 400;color: #FEFEFE;margin-right:5px;'
      },
      tableHeaderCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);background:#021950;text-align:center;font-size: 15px;font-weight: 400;color: #00FFFF;margin-right:5px;'
      },
      getEquipStatus(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/stats/equipment-status'

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data){
                this.onAmount = obj.data.onAmount
                this.offAmount = obj.data.offAmount
                this.faultedAmount = obj.data.faultedAmount
                this.surgeryAmount = obj.data.surgeryAmount
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      getEquipMonitorList(){
        this.loading = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/list-fault'

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          this.loading = false;
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.faults){
                // 获取设备数据
                this.tableData = obj.data.faults;
                areaSimplifyConversionUtil.codeToName(this.tableData);
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          this.loading = false;
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })

      },
      // 维护记录
      getMaintainRecord(id){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/maintenance';
        const data = {"id":id}

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          this.tableMaintainceData = []
          var obj = res.data;
            if(obj.code == 0){
                if(obj.data.maintenances){
                  // this.tableData = obj.data.maintenances;
                  var array = obj.data.maintenances;
                  for(var i=0;i<array.length;i++){
                    var element = array[i];
                    if(element.maintainStatus == 1){
                      element.maintainStatusText = '未处理'
                    }else if(element.maintainStatus == 1){
                      element.maintainStatusText = '处理中'
                    }else {
                      element.maintainStatusText = '处理完成'
                    }
                    // for(var i=0;i<50;i++){
                      this.tableMaintainceData.push(element)
                    // }
                  }
                }
            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },

      toHandleFault(row){
        this.$confirm('此操作将表示您开始处理该设备故障, 是否继续?', '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {
          this.toHandleFaultAction(row)
        }).catch(() => {

        });
      },
      toHandleFaultAction(row){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/maintenance-start'

        const data = {
          'eId':row.id
        }

        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message('处理中');
              this.getEquipMonitorList();
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      showMaintainRecord(row){
        this.dialogTableVisible = true;
        this.getMaintainRecord(row.id)
      },
      exportTable(type){
        var tableHeader = [];
        var dataList = [];
        var documentName = ''
        if(type==1){
          //设备监控列表
          tableHeader = [['序号','所在地区','使用单位','产品名称','规格型号','设备UDI','当前状态','故障时间','处理状态']];
          documentName = '设备监控列表'
          this.tableData.forEach((item,index)=>{
            dataList.push([
              index+1,
              item.provinceName,
              item.hospitalName,
              item.typeName,
              item.typeModel,
              item.udi,
              item.statusText,
              item.faultTime,
              item.maintainStatusText
            ]);
          });

        }else if(type == 2){
          this.dialogTableVisible = false;
          tableHeader = [['序号','故障时间','故障日志','开始处理时间','结束处理时间','处理时长(分钟)','维护内容','维护人','处理状态']];
          documentName = '设备维护记录'
          this.tableMaintainceData.forEach((item,index)=>{
            dataList.push([
              index+1,
              item.faultTime,
              item.faultLog,
              item.maintainStartTime,
              item.maintainFinishTime,
              item.maintainDuration,
              item.maintainProcess,
              item.maintainerName,
              item.maintainStatusText
            ]);
          });
        }

        if(dataList.length > 0){
          dataConversionUtil.dataToExcel(documentName,tableHeader,dataList)
          this.$message.success('导出成功')
        }else{
          this.$message.warning('无数据导出')
        }
        
      },
      judgePermissions(){
          let monitor1 = permissionCheckUtil.findName("equipment:read");
          if(monitor1==true){
            this.showEquipStat = true;
          }
      },
      sizeFun(){
        this.$nextTick(() => {
          if(this.showEquipStat==true){
            this.tableHeight = window.innerHeight-440 < 300 ? 300 : window.innerHeight-440;
          }else{
            this.tableHeight = window.innerHeight-220 < 300 ? 300 : window.innerHeight-220;
          }
          this.innerTableHeight = window.innerHeight*0.5 < 200 ? 200 : window.innerHeight*0.5;
        })
      },
    },
    mounted() {
      window.addEventListener('resize',this.sizeFun)

      this.sizeFun()

      if(this.showEquipStat==true){
        this.getEquipStatus()
      }
      this.getEquipMonitorList()
    },
    created() {
      this.judgePermissions();


    },
    beforeDestroy() {
      window.removeEventListener('resize',this.sizeFun)

    }
  }

</script>


<style lang="scss" scoped>
.container {
  margin-top: $header-height;

  .user-distribution{

    .handle-distribution{
      width: 100%;
      height: 210px;
      border-radius: 18px;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;

      .handle-one{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .line-left{
          display: flex;
          flex-direction: row;
          align-items: center;

          p{
            color: #11FFF1;
            opacity: 0.2;
            font-size: 18;
            font-weight: 400;
          }

          span{
            color: #11FFF1;
            font-size: 18px;
            font-weight: 400;
          }
        }

        .line-middle{
          width: 162px;
          height: 162px;
          border-radius: 18px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .line-middle-rate{
            font-size: 25px;
            font-family: Helvetica;
            font-weight: bold;
            color: #00DEFF;
            // text-shadow: 0px 10px 10px rgba(1,24,33,0.7);

            background: linear-gradient(0deg, #FF1800 0.1953125%, #D3CC15 99.6337890625%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-bottom: 0;

            span{
              font-size: 56px;
              font-weight: bold;
              background: linear-gradient(180deg, #D3CC15 0%, #FF1800 100%);

              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }

          .line-middle-rate-processing{
            font-size: 25px;
            font-family: Helvetica;
            font-weight: bold;
            color: #00DEFF;
            background: linear-gradient(0deg, #8033F2 0%, #00CCFF 99.6337890625%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-bottom: 0;

            span{
              font-size: 56px;
              font-weight: bold;
              background: linear-gradient(0deg, #8033F2 0%, #00CCFF 99.6337890625%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }

          .line-middle-rate-normal{
            font-size: 25px;
            font-family: Helvetica;
            font-weight: bold;
            color: #00DEFF;
            // text-shadow: 0px 10px 10px rgba(1,24,33,0.7);
            background: linear-gradient(0deg, #00FF54 0.1953125%, #15D3CC 99.6337890625%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-bottom: 0;

            span{
              font-size: 56px;
              font-weight: bold;
              background: linear-gradient(0deg, #00FF54 0.1953125%, #15D3CC 99.6337890625%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }

          .line-middle-rate-close{
            font-size: 25px;
            font-family: Helvetica;
            font-weight: bold;
            color: #eee;
            background: linear-gradient(0deg, #ddd 0.1953125%, #aaa 99.6337890625%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-bottom: 0;

            span{
              font-size: 56px;
              font-weight: bold;
              background: linear-gradient(0deg, #ddd 0.1953125%, #aaa 99.6337890625%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }



          .line-middle-status{
            font-size: 22px;

            font-weight: bold;
            color: #fff;
            text-shadow: 0px 10px 10px rgba(1,24,33,0.7);
            background: linear-gradient(180deg, #FFFFFF 0%, #47D6FF 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin: 0;
          }
        }

        .line-right{
          display: flex;
          flex-direction: row;
          align-items: center;

          p{
            color: #11FFF1;
            opacity: 0.2;
            font-size: 18;
            font-weight: 400;
          }

          span{
            color: #11FFF1;
            font-size: 18px;
            font-weight: 400;
          }
        }
      }
    }
  }

  .table-content{
    margin-top: $main-padding;

    .header-common{
      height: 45px;
      border-radius: 12px 12px 0 0;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .header-common-left{
        font-size: 20px;
        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;
      }
      .header-common-right{

        .right-button-export{
          font-size: 14px;
          font-weight: 400;
          color: #00FFB4;
          margin-right: 20px;
        }
      }
    }

    .table-list{

      .action-button-waiting{
        width: 89px;
        height: 36px;
        background: #FAFAFA;
        border: 1px solid rgba(0,255,96,0.84);
        border-radius: 20px;
        background-color: #208D7F;
        font-size: 14px;
        font-weight: 400;
        color: #00FFB4;
      }

      .action-button-process{
        width: 89px;
        height: 36px;
        background: #FAFAFA;
        border: 1px solid rgba(255, 132, 0, 0.84);
        border-radius: 20px;
        // background-color: #B26100;
        // color: #FFCC00;
        background-color: #D3CC15;
        color: black;
        // rgba(255, 132, 0, 0.84);
        font-size: 14px;
        font-weight: 400;

        display: inline-block;
        line-height: 36px;
        text-align: center;
        text-decoration: none;
      }

      .action-button-base{
        width: 89px;
        height: 36px;
        background: #FAFAFA;
        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 20px;
        background-color: #20478D;
        font-size: 14px;
        font-weight: 400;
        color: #00DEFF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/monitor/equipment/equipment-monitor.vue